import type { StepId } from '@hotjar/webapp/features/Activation/GetStartedGuide/types';
import type { USER_EXPERTISE, USER_GOALS } from '../user-personalization-info/types';

export enum GettingStartedGuideStateEnum {
  COMPLETED_KEY = 'done',
  SKIPPED_KEY = 'skipped',
  VIEWED_RECORDING_KEY = 'viewed_recording',
  VIEWED_HEATMAP_KEY = 'viewed_heatmap',
  INVITE_COMPLETED_KEY = 'invite_completed',
  CREATED_INCOMING_FEEDBACK_KEY = 'created_incoming_feedback',
  LAUNCHED_SURVEY_KEY = 'launched_survey',
  SAW_WELCOME_VIDEO = 'saw_welcome_video',
  SPACES_STEP_COMPLETED_KEY = 'spaces_step_completed',
  CELEBRATED_KEY = 'celebrated',
  HIGHLIGHTS_VIEWED = 'highlights_viewed',
  INTEGRATIONS_VIEWED = 'integrations_viewed',
  SEGMENTS_VIEWED = 'segments_viewed',
  GLOBAL_FILTERS_VIEWED = 'global_filters_viewed',
  LOCAL_FILTERS_VIEWED = 'local_filters_viewed',
}

export interface RawGettingStartedGuideState {
  [GettingStartedGuideStateEnum.COMPLETED_KEY]?: string | boolean;
  [GettingStartedGuideStateEnum.SKIPPED_KEY]?: string | boolean;
  [GettingStartedGuideStateEnum.VIEWED_RECORDING_KEY]?: string | boolean;
  [GettingStartedGuideStateEnum.VIEWED_HEATMAP_KEY]?: string | boolean;
  [GettingStartedGuideStateEnum.INVITE_COMPLETED_KEY]?: string | boolean;
  [GettingStartedGuideStateEnum.CREATED_INCOMING_FEEDBACK_KEY]?: string | boolean;
  [GettingStartedGuideStateEnum.LAUNCHED_SURVEY_KEY]?: string | boolean;
  [GettingStartedGuideStateEnum.SAW_WELCOME_VIDEO]?: string | boolean;
  [GettingStartedGuideStateEnum.SPACES_STEP_COMPLETED_KEY]?: string | boolean;
  [GettingStartedGuideStateEnum.CELEBRATED_KEY]?: string | boolean;
  [GettingStartedGuideStateEnum.HIGHLIGHTS_VIEWED]?: string | boolean;
  [GettingStartedGuideStateEnum.INTEGRATIONS_VIEWED]?: string | boolean;
  [GettingStartedGuideStateEnum.SEGMENTS_VIEWED]?: string | boolean;
  [GettingStartedGuideStateEnum.GLOBAL_FILTERS_VIEWED]?: string | boolean;
  [GettingStartedGuideStateEnum.LOCAL_FILTERS_VIEWED]?: string | boolean;
}

export interface CachedState {
  [id: number]: RawGettingStartedGuideState;
}

export interface UserExpertiseLevelGoals {
  [USER_GOALS.FEEDBACK]: StepId[];
  [USER_GOALS.HEATMAPS]: StepId[];
  [USER_GOALS.RECORDINGS]: StepId[];
  [USER_GOALS.SURVEYS]: StepId[];
  [USER_GOALS.SKIPPED]: StepId[];
}

export interface UserExpertiseOptions {
  [USER_EXPERTISE.BEGINNER]: Partial<UserExpertiseLevelGoals>;
  [USER_EXPERTISE.INTERMEDIATE]: Partial<UserExpertiseLevelGoals>;
  [USER_EXPERTISE.EXPERT]: Partial<UserExpertiseLevelGoals>;
  [USER_EXPERTISE.SKIP]?: Partial<UserExpertiseLevelGoals>;
}
